/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Discard_Confirm_TitleInputs */

const en_case_discard_confirm_title = /** @type {(inputs: Case_Discard_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard this case?`)
};

const pt_br2_case_discard_confirm_title = /** @type {(inputs: Case_Discard_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar este caso?`)
};

/**
* | output |
* | --- |
* | "Discard this case?" |
*
* @param {Case_Discard_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_discard_confirm_title = /** @type {((inputs?: Case_Discard_Confirm_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Discard_Confirm_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_discard_confirm_title(inputs)
	return pt_br2_case_discard_confirm_title(inputs)
});